import LTR from "@brand-icons/global/ui-quiz/ui-quiz-ltr.svg";

import { iconFactory } from "../iconFactory";

export const UiQuizIcon = iconFactory("UiQuizIcon", LTR);
